import { QueryClient } from '@tanstack/react-query'

// Chat is the heaviest surface: refetch-on-focus there would yank the
// streaming view out from under the user, so we disable it globally and
// re-enable per-query where it actually helps (memories, tasks).
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})
